'use client'

import PropTypes from 'prop-types'
import { LargeNotesIcon } from '@repo/ui/LargeNotesIcon'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUITypography from '@mui/material/Typography'

export const ThirdPartyFormReviewData = ({ updateStepState, wideMode, handlePrevNext }) => {
  const handleClickContinue = () => {
    updateStepState({ status: 'completed' })
    handlePrevNext(1)
  }

  return (
    <>
      <WizardPanel data-testid="ThirdPartyFormReviewData">
        <WizardIconTitle
          title="Review data"
          text="This step is coming soon."
          icon={LargeNotesIcon}
          sx={{ width: '100%' }}
        />
        <MUITypography variant="body1" sx={{ mt: 2 }}>
          Review the Osprey data that will populate the form here.
        </MUITypography>
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleClickContinue}
        handleClickBack={() => handlePrevNext(-1)}
        continueButtonText="Confirm"
      />
    </>
  )
}

ThirdPartyFormReviewData.propTypes = {
  updateStepState: PropTypes.func,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
